// extracted by mini-css-extract-plugin
module.exports = {"social-contact":"SocialContact_social-contact__2Pcom","social-icon-div":"SocialContact_social-icon-div__3fueS","social-icon":"SocialContact_social-icon__2AS0P"};